import { api } from "@/lib/api";
import { NETWORK_CONFIG } from "@/constants/network";

export const WEB3AUTH_CLIENT_ID = process.env.REACT_APP_WEB3AUTH_CLIENT_ID;
export const isWeb3AuthEnabled = Boolean(WEB3AUTH_CLIENT_ID);
const useDevnet = process.env.REACT_APP_WEB3AUTH_NETWORK === "sapphire_devnet";

let instancePromise;

// Lazily load the SDK (large bundle) and create one shared Web3Auth instance
export function getWeb3Auth() {
  instancePromise = instancePromise || (async () => {
    const { Web3Auth, WEB3AUTH_NETWORK, CHAIN_NAMESPACES } = await import("@web3auth/modal");
    const origin = window.location.origin;
    const web3auth = new Web3Auth({
      clientId: WEB3AUTH_CLIENT_ID,
      web3AuthNetwork: useDevnet ? WEB3AUTH_NETWORK.SAPPHIRE_DEVNET : WEB3AUTH_NETWORK.SAPPHIRE_MAINNET,
      chains: [{
        chainNamespace: CHAIN_NAMESPACES.EIP155, chainId: `0x${NETWORK_CONFIG.chainId.toString(16)}`,
        rpcTarget: NETWORK_CONFIG.rpcUrls[0], displayName: NETWORK_CONFIG.chainName, ticker: "FMI", tickerName: "FMI",
        decimals: 18, blockExplorerUrl: origin, logo: `${origin}/fmi-logo.png`, isTestnet: false,
      }],
      defaultChainId: `0x${NETWORK_CONFIG.chainId.toString(16)}`,
      sessionTime: 7 * 24 * 60 * 60,
      uiConfig: { appName: "FMI Smart Chain Hub", mode: "dark", logoDark: `${origin}/fmi-logo.png`, theme: { primary: "#D4AF37" } },
    });
    await web3auth.init();
    return web3auth;
  })().catch((e) => { instancePromise = null; throw e; });
  return instancePromise;
}

export async function connectWeb3Auth() {
  const web3auth = await getWeb3Auth();
  const connection = await web3auth.connect();
  const provider = connection?.ethereumProvider || web3auth.provider;
  if (!provider) throw new Error("Web3Auth did not return a wallet");
  return { web3auth, provider };
}

/** Verifies the Web3Auth login on the server (JWKS) and starts the FSC wallet session. */
export async function signInWithWeb3Auth(web3auth, address) {
  const { idToken } = await web3auth.getAuthTokenInfo();
  return api.post("/wallet-auth/web3auth", { idToken, address }, { withCredentials: true }).then((r) => r.data);
}

export async function logoutWeb3Auth() {
  if (!instancePromise) return;
  const web3auth = await instancePromise;
  if (web3auth.connected) await web3auth.logout().catch(() => {});
}
